(function () {
  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function formatCartMoney(cents) {
    if (window.theme && window.theme.Currency && window.theme.moneyFormat) {
      return window.theme.Currency.formatMoney(cents, window.theme.moneyFormat);
    }
    if (typeof Shopify !== "undefined" && Shopify.formatMoney && window.theme && window.theme.moneyFormat) {
      return Shopify.formatMoney(cents, window.theme.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  function readConfig(blockId) {
    var el = document.getElementById("fs-progress-json-" + blockId);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function resolveThresholdCents(root) {
    return parseInt(root.getAttribute("data-threshold-cents"), 10) || 0;
  }

  function updateFreeShippingBars() {
    var roots = document.querySelectorAll("[data-free-shipping-progress]");
    if (!roots.length) return;

    fetch("/cart.js")
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var total = cart.total_price || 0;
        roots.forEach(function (root) {
          var threshold = resolveThresholdCents(root);
          var id = root.getAttribute("data-block-id");
          var cfg = id ? readConfig(id) : null;
          if (!threshold) return;

          var pct = Math.min(100, Math.floor((total * 100) / threshold));
          var remain = Math.max(0, threshold - total);

          var fill = root.querySelector(".fs-progress__fill");
          var track = root.querySelector(".fs-progress__track");
          if (fill) fill.style.width = pct + "%";
          if (track) track.setAttribute("aria-valuenow", String(pct));

          var elSuc = root.querySelector(".fs-progress__message--success");
          var elProg = root.querySelector(".fs-progress__message--progress");
          var amt = root.querySelector(".fs-progress__amount");

          if (remain <= 0) {
            root.classList.add("fs-progress--complete");
            if (elSuc) {
              elSuc.classList.remove("hidden");
              var lead =
                cfg && typeof cfg.successLead === "string"
                  ? cfg.successLead
                  : "Your order qualifies for";
              var label =
                cfg && typeof cfg.freeLabel === "string" ? cfg.freeLabel : "Free Shipping!";
              elSuc.innerHTML =
                escapeHtml(lead).replace(/\s+$/g, "") +
                " " +
                '<strong class="fs-progress__free-label">' +
                escapeHtml(label) +
                "</strong>";
            }
            if (elProg) elProg.classList.add("hidden");
          } else {
            root.classList.remove("fs-progress--complete");
            if (elSuc) elSuc.classList.add("hidden");
            if (elProg) elProg.classList.remove("hidden");
            if (amt) {
              // formatMoney returns HTML (e.g. <span class="money">…</span>); use innerHTML not textContent
              amt.innerHTML = formatCartMoney(remain);
              if (
                window.theme &&
                window.theme.mlcurrency &&
                typeof window.currenciesChange === "function"
              ) {
                window.currenciesChange(".fs-progress__amount.money");
              }
            }
          }
        });
      })
      .catch(function () {});
  }

  function initFreeShippingProgress() {
    updateFreeShippingBars();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initFreeShippingProgress);
  } else {
    initFreeShippingProgress();
  }

  if (typeof jQuery !== "undefined") {
    jQuery(document).on("cart.requestComplete", updateFreeShippingBars);
    jQuery(document).on("currency.changed", function () {
      setTimeout(updateFreeShippingBars, 100);
    });
  }
})();
